module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-504c8fbe.png";